/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_3_AInputs */

const en_mk_tut_tr_3_a = /** @type {(inputs: Mk_Tut_Tr_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The name has to be picked from the list that appears after you type \`@\`, not typed by hand. If the name is missing, that agent has no access to the channel yet.`)
};

const id_mk_tut_tr_3_a = /** @type {(inputs: Mk_Tut_Tr_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama harus dipilih dari daftar yang muncul setelah Anda mengetik \`@\`, bukan diketik manual. Kalau namanya tidak muncul, agen itu belum punya akses ke channel tersebut.`)
};

/**
* | output |
* | --- |
* | "The name has to be picked from the list that appears after you type `@`, not typed by hand. If the name is missing, that agent has no access to the channel yet." |
*
* @param {Mk_Tut_Tr_3_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_3_a = /** @type {((inputs?: Mk_Tut_Tr_3_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_3_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_3_a(inputs)
	return en_mk_tut_tr_3_a(inputs)
});